import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Divider,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Loader,
  Modal,
  Popup,
  Segment,
} from 'semantic-ui-react';
import { withTranslation, Trans } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { flashSuccessMessage } from '../../actions/flash';
import config from '../../../config';

class ShareESign extends Component {
  static propTypes = {
    trigger: PropTypes.node,
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    bookingData: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    customerData: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    onClose: PropTypes.func,
    loading: PropTypes.bool,
    open: PropTypes.bool,
    isMobile: PropTypes.bool,
    onProceed: PropTypes.func,
    onRenew: PropTypes.func,
    onSend: PropTypes.func,
    printTemplates: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    // CPI-976: preserved for a future Vietnam E-Sign rollout; the Purchaser parent currently
    // hides this modal for Vietnam.
    isVietnam: PropTypes.bool,
    t: PropTypes.func,
  }

  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultProps = {
    isVietnam: false,
  }
  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      open: false,
      modalOpen: false,
      smsSendable: true,
      emailSendable: true,
      selectedPrintForms: [],
      allowSendEmail: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const { open, bookingData } = nextProps;
    const allowSendEmail = bookingData.project && bookingData.project.shareESignSendFormsEmail;
    if (open) {
      this.setState({
        open,
        allowSendEmail,
      });
    }
  }
  getShareUrl = () => {
    const { data } = this.props;
    const buyerURL = config.get('buyerURL');
    if (data && data.shortID && buyerURL) {
      const shareURL = `${buyerURL}/en/sign/${data.shortID}`;
      return shareURL;
    }
    return '';
  }
  getToken = () => {
    const { data } = this.props;
    return data && data.token;
  }
  handleOnOpen = (e) => {
    e.preventDefault();
    this.setState({ open: true });
  }
  close() {
    this.handleOnClose(true);
  }
  handleOnClose = (e) => {
    const open = false;
    if (this.props.onClose) {
      this.props.onClose(e);
    }
    this.setState({
      open,
      smsSendable: true,
      emailSendable: true,
      selectedPrintForms: [],
    });
  }
  handleCopy = (e, name) => {
    e.preventDefault();
    const { store } = this.context;
    const { t } = this.props;
    let copyText = this.getShareUrl();
    let msgTitle = 'web address';
    if (name === 'pin') {
      copyText = this.getToken();
      msgTitle = '6-digit PIN';
    }
    const tempText = document.createElement('input');
    tempText.value = copyText;
    document.body.appendChild(tempText);
    tempText.select();
    document.execCommand('copy');
    tempText.remove();

    store.dispatch(flashSuccessMessage({
      header: t('Copy Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Successfully copied the {{title}} to your clipboard', { title: t(msgTitle), ns: TRANSLATION_FILES.translation }),
    }));
  }
  handleInputChange = (e, { value }) => {
    const selectedTemplates = this.props.printTemplates.filter(t => value.includes(t.value));

    const selectedDocxTemplates = selectedTemplates
    .filter(t => t.type === 'docx')
    .map(t => t.value);

    const selectedPrintTemplates = selectedTemplates
    .filter(t => t.type !== 'docx')
    .map(t => t.value);

    this.setState({
      selectedDocxTemplates,
      selectedPrintTemplates,
      selectedPrintForms: value,
    });
  }
  handleProceed = (e) => {
    const { onProceed } = this.props;
    const { allowSendEmail, selectedDocxTemplates, selectedPrintTemplates } = this.state;
    const data = {
      printTemplateIDs: selectedPrintTemplates,
      docxTemplateIDs: selectedDocxTemplates,
      allowSendFormsEmail: allowSendEmail,
    };
    onProceed(e, data);
  }
  handleOnRenew = (e) => {
    if (this.props.onRenew) {
      this.props.onRenew(e);
      this.setState({ selectedPrintForms: [] });
    }
  }
  handleOnSend = (e, type) => {
    if (this.props.onSend) {
      this.props.onSend(e, type);
      this.setState({ smsSendable: false });

      // set timeout to re-enable button after 1 minute
      this.timer = setTimeout(() => {
        this.setState({ smsSendable: true });
        // clear timeout after use
        this.timer = null;
      }, 60000);
    }
  }
  // CPI-976: preserved email channel for Vietnam. Own cooldown flag so the SMS path above stays
  // byte-identical.
  handleOnSendEmail = (e) => {
    if (this.props.onSend) {
      this.props.onSend(e, 'email');
      this.setState({ emailSendable: false });

      this.emailTimer = setTimeout(() => {
        this.setState({ emailSendable: true });
        this.emailTimer = null;
      }, 60000);
    }
  }
  handleCheckboxChange = (e) => {
    e.preventDefault();
    this.setState({
      allowSendEmail: !this.state.allowSendEmail,
    });
  }

  render() {
    const {
      bookingData,
      customerData,
      isMobile,
      isVietnam,
      loading,
      printTemplates,
      t,
      trigger,
    } = this.props;
    const {
      allowSendEmail,
      smsSendable,
      emailSendable,
      selectedPrintForms,
    } = this.state;
    const pin6Digits = this.getToken() && this.getToken().split('');
    const showFormStep = !this.getToken();
    const header = showFormStep ? 'E-signature sharing configuration' : 'Share e-signature form to Purchaser';
    const hasCustomerEmail = customerData.email !== '';
    return (
      <Modal
        className="share-e-sign"
        closeOnDimmerClick={false}
        size="tiny"
        trigger={trigger}
        open={this.state.open}
        onClose={this.handleOnCancel}
        onOpen={this.handleOnOpen}

      >
        <Header
          icon="share square"
          content={t(header)}
        />
        {
          loading ? (
            <div className="loading-div">
              <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
            </div>
          ) : (
            <Modal.Content>
              { showFormStep ? (
                <div style={{ marginBottom: '40px' }}>
                  <Header
                    as="h5"
                    style={{ margin: '0 0 5px 0' }}
                  >
                    {t('Select form to share with Purchaser')}
                    <Popup
                      content={t('Selecting a form from the dropdown below allows the purchaser to preview and verify its details before signing')}
                      position="right center"
                      trigger={<Button
                        icon="info circle"
                        style={{ paddingLeft: '0.2em', background: 'none' }}
                      />}
                    />
                  </Header>
                  <Dropdown
                    name="selectedPrintForms"
                    fluid
                    multiple
                    search
                    selection
                    placeholder={t('Select form')}
                    options={printTemplates}
                    onChange={this.handleInputChange}
                    value={selectedPrintForms}
                    style={{ marginBottom: '20px' }}
                  />
                  <Form.Checkbox
                    label={
                      <label htmlFor="allowSendEmail">
                        {t('Automatically share the e-signed copies of the selected forms with purchaser via email')}
                        { !hasCustomerEmail && (
                          <Popup
                            content={t("Purchaser's email required")}
                            position="right center"
                            trigger={<Button
                              icon="info circle"
                              style={{ paddingLeft: '0.2em', background: 'none' }}
                            />}
                          />
                        )}
                      </label>
                    }
                    checked={allowSendEmail}
                    onChange={this.handleCheckboxChange}
                    disabled={!hasCustomerEmail}
                  />
                </div>
              ) : (
                <div>
                  <p>{t('To obtain an e-signature from your purchaser, choose the method of sharing to your purchaser below')}:</p>
                  <Grid>
                    <Grid.Row centered>
                      { customerData.mobilePrefix === '60' && (
                        <Grid.Column computer={3} tablet={3} mobile={3}>
                          <Grid.Row>
                            <Button
                              primary
                              circular
                              icon
                              size="large"
                              disabled={loading || !smsSendable}
                              onClick={e => this.handleOnSend(e, 'sms')}
                            >
                              <Icon name="chat" />
                            </Button>
                            <p className={`${!smsSendable ? 'disabled' : ''}`}>{t('SMS')}</p>
                          </Grid.Row>
                          { !smsSendable &&
                            <Grid.Row className="shared-text">
                              {t('Shared')}
                            </Grid.Row>
                          }
                        </Grid.Column>
                      )}
                      { isVietnam && (
                        <Grid.Column computer={3} tablet={3} mobile={3}>
                          <Grid.Row>
                            <Popup
                              disabled={hasCustomerEmail}
                              content={t("Purchaser's email required")}
                              position="top center"
                              trigger={
                                <div style={{ display: 'inline-block' }}>
                                  <Button
                                    primary
                                    circular
                                    icon
                                    size="large"
                                    disabled={loading || !emailSendable || !hasCustomerEmail}
                                    onClick={this.handleOnSendEmail}
                                  >
                                    <Icon name="mail" />
                                  </Button>
                                </div>
                              }
                            />
                            <p className={`${(!emailSendable || !hasCustomerEmail) ? 'disabled' : ''}`}>{t('Email')}</p>
                          </Grid.Row>
                          { !emailSendable &&
                            <Grid.Row className="shared-text">
                              {t('Shared')}
                            </Grid.Row>
                          }
                        </Grid.Column>
                      )}
                      <Grid.Column computer={3} tablet={3} mobile={3}>
                        <Button
                          secondary
                          circular
                          icon
                          size="large"
                          disabled={loading}
                          onClick={e => this.handleCopy(e, 'url')}
                        >
                          <Icon name="linkify" />
                        </Button>
                        <p>{t('Copy URL')}</p>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  { !isVietnam && (
                    <p className="share-note">
                      *{t('Share via SMS will also include 6-digit PIN and only available for Malaysia number')}
                    </p>
                  )}
                  <Divider />
                </div>
              )}
              { !showFormStep &&
                bookingData.project && bookingData.project.shareESignPinIsRequired && (
                <div>
                  <p>{t('Please share the following 6-digit PIN with your purchaser to grant them access to the e-signature form')}:</p>
                  <Grid centered columns={7} style={isMobile ? { margin: '20px 20px 0' } : { margin: '20px 65px 0' }}>
                    {pin6Digits && pin6Digits.map((pin, index) => (
                      <Grid.Column key={index} style={{ padding: '0.3em' }}>
                        <Segment textAlign="center" style={isMobile ? { padding: '15px 0' } : { padding: '1em 0' }}>
                          <Header
                            as="h3"
                            content={pin}
                          />
                        </Segment>
                      </Grid.Column>
                    ))}
                    <Grid.Column className="copy-pin">
                      <Icon name="copy outline" link onClick={e => this.handleCopy(e, 'pin')} />
                    </Grid.Column>
                  </Grid>
                  <Segment className="renew">
                    <Trans ns={TRANSLATION_FILES.screens}>
                      <p>
                        There are changes in the booking information? Click{' '}
                        <button onClick={this.handleOnRenew}>
                          here
                        </button>{' '}
                        to generate the latest link.
                      </p>
                    </Trans>
                  </Segment>
                </div>
              )}
            </Modal.Content>
          )
        }
        <Modal.Actions>
          <Button
            onClick={this.handleOnClose}
            content={t('Close', { ns: TRANSLATION_FILES.translation })}
          />
          { showFormStep &&
            <Button
              primary
              onClick={this.handleProceed}
              content={t('Proceed', { ns: TRANSLATION_FILES.translation })}
            />
          }
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(ShareESign);



// WEBPACK FOOTER //
// ./src/containers/modals/ShareESign.jsx